import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeout: Number
  }

  connect() {
    if (!this.hasTimeoutValue) return

    this.dismissTimeout = setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  disconnect() {
    clearTimeout(this.dismissTimeout)
    clearTimeout(this.removeTimeout)
  }

  dismiss() {
    this.element.classList.add("opacity-0")
    this.removeTimeout = setTimeout(() => this.element.remove(), 200)
  }
}
